import { render, staticRenderFns } from "./InsertUser.vue?vue&type=template&id=24bb99d0"
import script from "./InsertUser.vue?vue&type=script&lang=js"
export * from "./InsertUser.vue?vue&type=script&lang=js"
import style0 from "./InsertUser.vue?vue&type=style&index=0&id=24bb99d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports